export const testing = 'testing';

// setting the baseurl for api call from here

export const API_BASE_PATH: string | undefined = `${process.env.REACT_APP_API_BASE_PATH}/`;
export const GET_GEO_LOCATION_URL: string = `${process.env.REACT_APP_GET_GEO_LOCATION_URL}`;